import { INavigationMenuItem } from '@/utils/types/navigation';
import { graphql, useStaticQuery } from 'gatsby';

// Fallback menu items in case Contentful data is not available
const fallbackMenuItems: INavigationMenuItem[] = [
  {
    title: 'What we do',
    type: 'header',
    identifier: 'what-we-do',
    order: 1,
    submenu: [
      { title: 'EverlyCare', link: '/everlycare' },
      {
        title: 'EverlyCare Annual',
        link: '/products/everlycare-annual-health-screenings',
      },
      { title: 'Diabetes', link: '/products/diabetes-testing-management' },
      { title: 'Heart health', link: '/products/heart-health-blood-tests' },
      {
        title: 'Colorectal cancer',
        link: '/products/colorectal-cancer-screening',
      },
    ],
  },
  {
    title: 'Who we serve',
    type: 'header',
    identifier: 'who-we-serve',
    order: 2,
    submenu: [
      { title: 'Health Plans', link: '/health-plans' },
      { title: 'Employers', link: '/employers' },
      { title: 'Life Sciences', link: '/life-sciences' },
      { title: 'Labs', link: '/labs' },
      { title: 'Providers', link: '/providers' },
      { title: 'Partners', link: '/partners' },
    ],
  },
  {
    title: 'Resources',
    type: 'header',
    identifier: 'resources',
    order: 3,
    submenu: [
      { title: 'Resource Center', link: '/resources' },
      { title: 'For Patients', link: '/patients' },
    ],
  },
];

interface UseNavigationProps {
  menuType?: string;
}

export const useNavigation = ({
  menuType = 'header',
}: UseNavigationProps = {}) => {
  const data = useStaticQuery(graphql`
    query NavigationQuery {
      allContentfulNavigationMenu(filter: { node_locale: { eq: "en-US" } }) {
        nodes {
          contentful_id
          menuTitle
          menuType
          menuIdentifier
          order
          menuItems {
            contentful_id
            title
            link
          }
        }
      }
    }
  `);

  // Transform GraphQL data to match the expected format
  const transformedMenuItems = data.allContentfulNavigationMenu.nodes
    .filter((node: any) => node.menuType === menuType)
    .map(
      (node: any): INavigationMenuItem => ({
        title: node.menuTitle,
        type: node.menuType,
        identifier: node.menuIdentifier,
        order: node.order || 0,
        submenu:
          node.menuItems
            ?.filter(
              (item: { title?: string; link?: string }) =>
                item?.title && item?.link,
            )
            .map((item: { title: string; link: string }) => ({
              title: item.title,
              link: item.link,
            })) || [],
      }),
    )
    .sort(
      (a: INavigationMenuItem, b: INavigationMenuItem) => a.order - b.order,
    );

  return {
    menuItems:
      transformedMenuItems.length > 0
        ? transformedMenuItems
        : fallbackMenuItems,
    loading: false,
    error: null,
  };
};
